export { default } from './payment-plans';

